import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { PropertySettings, PropertySettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const baseUrl = `${SETTINGS_BASE_URL}/property`;

export class PropertySettingsRepository extends BaseRestRepository {
  public async getAllPropertySettings(): Promise<PropertySettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${baseUrl}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getPropertySettingsByLevel(level: string, levelId: string): Promise<PropertySettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updatePropertySettings(payload: PropertySettings): Promise<PropertySettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async updatePropertySettingsByLevel(level: string, levelId: string, payload: PropertySettings): Promise<PropertySettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deletePropertySettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
